export default defineNuxtPlugin(() => {
  const anonymousId = () => {
    window.segmentstream ||= {
      anonymousId: () => undefined,
    };

    return window.segmentstream.anonymousId();
  };

  return {
    provide: {
      segmentstream: {
        anonymousId,
      },
    },
  };
});
